import { darken, getLightnessLevel, lighten, isTransparent } from '../../../../../../lib/color';
import { LIGHTNESS_THRESHOLD } from '../../../../constants';

/**
 * Calculates the relevant linear-gradient settings according to the lightness/transparency of the given color.
 * @param color
 * @return {String} - the linear-gradient style property
 */
const calcLinearGradient = (color) => {
    const lightnessLevel = getLightnessLevel(color);
    const isLight = lightnessLevel >= LIGHTNESS_THRESHOLD;

    if (isLight) {
        return `linear-gradient(250deg, ${lighten(color, 0.0)} 50%, ${darken(color, 0.1)}) 100%`;
    } else if (isTransparent(color)) {
        return `linear-gradient(250deg, ${lighten(color, 0.1)} 0%, ${darken(color, 0.1)}) 100%`;
    } else {
        return `linear-gradient(235deg, ${lighten(color, 0.9)} 0%, ${darken(color, 0.1)}) 100%`;
    }
};

export default calcLinearGradient;
